export class DatepickerSettingModel {
  jpEras = [
    {
      name: '令和',
      startDay: 1,
      startMonth: 5,
      startYear: 2019,
    },
    {
      name: '平成',
      startDay: 8,
      startMonth: 1,
      startYear: 1989,
    },
    {
      name: '昭和',
      startDay: 25,
      startMonth: 12,
      startYear: 1926,
    },
    {
      name: '大正',
      startDay: 30,
      startMonth: 7,
      startYear: 1912,
    },
    {
      name: '明治',
      startDay: 23,
      startMonth: 10,
      startYear: 1868,
    },
    {
      name: '慶応',
      startDay: 1,
      startMonth: 5,
      startYear: 1865,
    },
    {
      name: '元治',
      startDay: 1,
      startMonth: 1,
      startYear: 1864,
    },
    {
      name: '文久',
      startDay: 1,
      startMonth: 1,
      startYear: 1861,
    },
    {
      name: '万延',
      startDay: 1,
      startMonth: 1,
      startYear: 1860,
    },
    {
      name: '万延',
      startDay: 1,
      startMonth: 1,
      startYear: 1860,
    },
    {
      name: '安政',
      startDay: 1,
      startMonth: 1,
      startYear: 1855,
    },
    {
      name: '嘉永',
      startDay: 1,
      startMonth: 1,
      startYear: 1848,
    },
    {
      name: '弘化',
      startDay: 1,
      startMonth: 1,
      startYear: 1845,
    },
    {
      name: '天保',
      startDay: 1,
      startMonth: 1,
      startYear: 1831,
    },
    {
      name: '文政',
      startDay: 1,
      startMonth: 1,
      startYear: 1818,
    },
    {
      name: '文化',
      startDay: 1,
      startMonth: 1,
      startYear: 1804,
    },
    {
      name: '享和',
      startDay: 1,
      startMonth: 1,
      startYear: 1801,
    },
    {
      name: '寛政',
      startDay: 1,
      startMonth: 1,
      startYear: 1789,
    },
    {
      name: '天明',
      startDay: 1,
      startMonth: 1,
      startYear: 1781,
    },
    {
      name: '安永',
      startDay: 1,
      startMonth: 1,
      startYear: 1772,
    },
    {
      name: '明和',
      startDay: 1,
      startMonth: 1,
      startYear: 1764,
    },
    {
      name: '宝暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1751,
    },
    {
      name: '寛延',
      startDay: 1,
      startMonth: 1,
      startYear: 1748,
    },
    {
      name: '延享',
      startDay: 1,
      startMonth: 1,
      startYear: 1744,
    },
    {
      name: '寛保',
      startDay: 1,
      startMonth: 1,
      startYear: 1741,
    },
    {
      name: '元文',
      startDay: 1,
      startMonth: 1,
      startYear: 1736,
    },
    {
      name: '享保',
      startDay: 1,
      startMonth: 1,
      startYear: 1716,
    },
    {
      name: '正徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1711,
    },
    {
      name: '宝永',
      startDay: 1,
      startMonth: 1,
      startYear: 1704,
    },
    {
      name: '元禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1688,
    },
    {
      name: '貞享',
      startDay: 1,
      startMonth: 1,
      startYear: 1684,
    },
    {
      name: '天和',
      startDay: 1,
      startMonth: 1,
      startYear: 1681,
    },
    {
      name: '延宝',
      startDay: 1,
      startMonth: 1,
      startYear: 1673,
    },
    {
      name: '寛文',
      startDay: 1,
      startMonth: 1,
      startYear: 1661,
    },
    {
      name: '万治',
      startDay: 1,
      startMonth: 1,
      startYear: 1658,
    },
    {
      name: '明暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1655,
    },
    {
      name: '承応',
      startDay: 1,
      startMonth: 1,
      startYear: 1652,
    },
    {
      name: '慶安',
      startDay: 1,
      startMonth: 1,
      startYear: 1648,
    },
    {
      name: '正保',
      startDay: 1,
      startMonth: 1,
      startYear: 1645,
    },
    {
      name: '寛永',
      startDay: 1,
      startMonth: 1,
      startYear: 1624,
    },
    {
      name: '元和',
      startDay: 1,
      startMonth: 1,
      startYear: 1615,
    },
    {
      name: '慶長',
      startDay: 1,
      startMonth: 1,
      startYear: 1596,
    },
    {
      name: '文禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1593,
    },
    {
      name: '天正',
      startDay: 1,
      startMonth: 1,
      startYear: 1573,
    },
    {
      name: '元亀',
      startDay: 1,
      startMonth: 1,
      startYear: 1570,
    },
    {
      name: '永禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1558,
    },
    {
      name: '弘治',
      startDay: 1,
      startMonth: 1,
      startYear: 1555,
    },
    {
      name: '天文',
      startDay: 1,
      startMonth: 1,
      startYear: 1532,
    },
    {
      name: '享禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1528,
    },
    {
      name: '大永',
      startDay: 1,
      startMonth: 1,
      startYear: 1521,
    },
    {
      name: '永正',
      startDay: 1,
      startMonth: 1,
      startYear: 1504,
    },
    {
      name: '文亀',
      startDay: 1,
      startMonth: 1,
      startYear: 1501,
    },
    {
      name: '明応',
      startDay: 1,
      startMonth: 1,
      startYear: 1492,
    },
    {
      name: '延徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1489,
    },
    {
      name: '長享',
      startDay: 1,
      startMonth: 1,
      startYear: 1487,
    },
    {
      name: '文明',
      startDay: 1,
      startMonth: 1,
      startYear: 1469,
    },
    {
      name: '応仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1467,
    },
    {
      name: '文正',
      startDay: 1,
      startMonth: 1,
      startYear: 1466,
    },
    {
      name: '寛正',
      startDay: 1,
      startMonth: 1,
      startYear: 1461,
    },
    {
      name: '長禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1457,
    },
    {
      name: '康正',
      startDay: 1,
      startMonth: 1,
      startYear: 1455,
    },
    {
      name: '享徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1452,
    },
    {
      name: '宝徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1449,
    },
    {
      name: '文安',
      startDay: 1,
      startMonth: 1,
      startYear: 1444,
    },
    {
      name: '嘉吉',
      startDay: 1,
      startMonth: 1,
      startYear: 1441,
    },
    {
      name: '永享',
      startDay: 1,
      startMonth: 1,
      startYear: 1429,
    },
    {
      name: '正長',
      startDay: 1,
      startMonth: 1,
      startYear: 1428,
    },
    {
      name: '応永',
      startDay: 1,
      startMonth: 1,
      startYear: 1394,
    },
    {
      name: '明徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1390,
    },
    {
      name: '康応',
      startDay: 1,
      startMonth: 1,
      startYear: 1389,
    },
    {
      name: '嘉慶',
      startDay: 1,
      startMonth: 1,
      startYear: 1387,
    },
    {
      name: '至徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1384,
    },
    {
      name: '永徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1381,
    },
    {
      name: '康暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1379,
    },
    {
      name: '永和',
      startDay: 1,
      startMonth: 1,
      startYear: 1375,
    },
    {
      name: '文中',
      startDay: 1,
      startMonth: 1,
      startYear: 1372,
    },
    {
      name: '建徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1370,
    },
    {
      name: '応安',
      startDay: 1,
      startMonth: 1,
      startYear: 1368,
    },
    {
      name: '貞治',
      startDay: 1,
      startMonth: 1,
      startYear: 1362,
    },
    {
      name: '康安',
      startDay: 1,
      startMonth: 1,
      startYear: 1361,
    },
    {
      name: '延文',
      startDay: 1,
      startMonth: 1,
      startYear: 1356,
    },
    {
      name: '文和',
      startDay: 1,
      startMonth: 1,
      startYear: 1352,
    },
    {
      name: '観応',
      startDay: 1,
      startMonth: 1,
      startYear: 1350,
    },
    {
      name: '正平',
      startDay: 1,
      startMonth: 1,
      startYear: 1347,
    },
    {
      name: '貞和',
      startDay: 1,
      startMonth: 1,
      startYear: 1345,
    },
    {
      name: '康永',
      startDay: 1,
      startMonth: 1,
      startYear: 1342,
    },
    {
      name: '興国',
      startDay: 1,
      startMonth: 1,
      startYear: 1340,
    },
    {
      name: '暦応',
      startDay: 1,
      startMonth: 1,
      startYear: 1338,
    },
    {
      name: '延元',
      startDay: 1,
      startMonth: 1,
      startYear: 1336,
    },
    {
      name: '建武',
      startDay: 1,
      startMonth: 1,
      startYear: 1334,
    },
    {
      name: '正慶',
      startDay: 1,
      startMonth: 1,
      startYear: 1332,
    },
    {
      name: '元徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1329,
    },
    {
      name: '嘉暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1326,
    },
    {
      name: '正中',
      startDay: 1,
      startMonth: 1,
      startYear: 1324,
    },
    {
      name: '元亨',
      startDay: 1,
      startMonth: 1,
      startYear: 1321,
    },
    {
      name: '元応',
      startDay: 1,
      startMonth: 1,
      startYear: 1319,
    },
    {
      name: '文保',
      startDay: 1,
      startMonth: 1,
      startYear: 1317,
    },
    {
      name: '正和',
      startDay: 1,
      startMonth: 1,
      startYear: 1312,
    },
    {
      name: '応長',
      startDay: 1,
      startMonth: 1,
      startYear: 1311,
    },
    {
      name: '延慶',
      startDay: 1,
      startMonth: 1,
      startYear: 1308,
    },
    {
      name: '徳治',
      startDay: 1,
      startMonth: 1,
      startYear: 1307,
    },
    {
      name: '嘉元',
      startDay: 1,
      startMonth: 1,
      startYear: 1303,
    },
    {
      name: '正安',
      startDay: 1,
      startMonth: 1,
      startYear: 1299,
    },
    {
      name: '永仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1293,
    },
    {
      name: '正応',
      startDay: 1,
      startMonth: 1,
      startYear: 1288,
    },
    {
      name: '弘安',
      startDay: 1,
      startMonth: 1,
      startYear: 1278,
    },
    {
      name: '建治',
      startDay: 1,
      startMonth: 1,
      startYear: 1275,
    },
    {
      name: '文永',
      startDay: 1,
      startMonth: 1,
      startYear: 1264,
    },
    {
      name: '弘長',
      startDay: 1,
      startMonth: 1,
      startYear: 1261,
    },
    {
      name: '文応',
      startDay: 1,
      startMonth: 1,
      startYear: 1260,
    },
    {
      name: '正元',
      startDay: 1,
      startMonth: 1,
      startYear: 1259,
    },
    {
      name: '正嘉',
      startDay: 1,
      startMonth: 1,
      startYear: 1257,
    },
    {
      name: '康元',
      startDay: 1,
      startMonth: 1,
      startYear: 1256,
    },
    {
      name: '建長',
      startDay: 1,
      startMonth: 1,
      startYear: 1249,
    },
    {
      name: '宝治',
      startDay: 1,
      startMonth: 1,
      startYear: 1247,
    },
    {
      name: '寛元',
      startDay: 1,
      startMonth: 1,
      startYear: 1243,
    },
    {
      name: '仁治',
      startDay: 1,
      startMonth: 1,
      startYear: 1240,
    },
    {
      name: '延応',
      startDay: 1,
      startMonth: 1,
      startYear: 1239,
    },
    {
      name: '暦仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1238,
    },
    {
      name: '嘉禎',
      startDay: 1,
      startMonth: 1,
      startYear: 1235,
    },
    {
      name: '文暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1234,
    },
    {
      name: '天福',
      startDay: 1,
      startMonth: 1,
      startYear: 1233,
    },
    {
      name: '貞永',
      startDay: 1,
      startMonth: 1,
      startYear: 1232,
    },
    {
      name: '寛喜',
      startDay: 1,
      startMonth: 1,
      startYear: 1229,
    },
    {
      name: '安貞',
      startDay: 1,
      startMonth: 1,
      startYear: 1228,
    },
    {
      name: '嘉禄',
      startDay: 1,
      startMonth: 1,
      startYear: 1225,
    },
    {
      name: '元仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1224,
    },
    {
      name: '貞応',
      startDay: 1,
      startMonth: 1,
      startYear: 1222,
    },
    {
      name: '承久',
      startDay: 1,
      startMonth: 1,
      startYear: 1219,
    },
    {
      name: '建保',
      startDay: 1,
      startMonth: 1,
      startYear: 1214,
    },
    {
      name: '建暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1211,
    },
    {
      name: '承元',
      startDay: 1,
      startMonth: 1,
      startYear: 1207,
    },
    {
      name: '建永',
      startDay: 1,
      startMonth: 1,
      startYear: 1206,
    },
    {
      name: '元久',
      startDay: 1,
      startMonth: 1,
      startYear: 1204,
    },
    {
      name: '建仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1201,
    },
    {
      name: '正治',
      startDay: 1,
      startMonth: 1,
      startYear: 1199,
    },
    {
      name: '建久',
      startDay: 1,
      startMonth: 1,
      startYear: 1190,
    },
    {
      name: '文治',
      startDay: 1,
      startMonth: 1,
      startYear: 1185,
    },
    {
      name: '元暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1184,
    },
    {
      name: '寿永',
      startDay: 1,
      startMonth: 1,
      startYear: 1182,
    },
    {
      name: '養和',
      startDay: 1,
      startMonth: 1,
      startYear: 1181,
    },
    {
      name: '治承',
      startDay: 1,
      startMonth: 1,
      startYear: 1177,
    },
    {
      name: '安元',
      startDay: 1,
      startMonth: 1,
      startYear: 1175,
    },
    {
      name: '承安',
      startDay: 1,
      startMonth: 1,
      startYear: 1171,
    },
    {
      name: '嘉応',
      startDay: 1,
      startMonth: 1,
      startYear: 1169,
    },
    {
      name: '仁安',
      startDay: 1,
      startMonth: 1,
      startYear: 1166,
    },
    {
      name: '永万',
      startDay: 1,
      startMonth: 1,
      startYear: 1165,
    },
    {
      name: '長寛',
      startDay: 1,
      startMonth: 1,
      startYear: 1163,
    },
    {
      name: '応保',
      startDay: 1,
      startMonth: 1,
      startYear: 1161,
    },
    {
      name: '永暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1160,
    },
    {
      name: '平治',
      startDay: 1,
      startMonth: 1,
      startYear: 1159,
    },
    {
      name: '保元',
      startDay: 1,
      startMonth: 1,
      startYear: 1156,
    },
    {
      name: '久寿',
      startDay: 1,
      startMonth: 1,
      startYear: 1154,
    },
    {
      name: '仁平',
      startDay: 1,
      startMonth: 1,
      startYear: 1151,
    },
    {
      name: '久安',
      startDay: 1,
      startMonth: 1,
      startYear: 1145,
    },
    {
      name: '天養',
      startDay: 1,
      startMonth: 1,
      startYear: 1144,
    },
    {
      name: '康治',
      startDay: 1,
      startMonth: 1,
      startYear: 1142,
    },
    {
      name: '永治',
      startDay: 1,
      startMonth: 1,
      startYear: 1141,
    },
    {
      name: '保延',
      startDay: 1,
      startMonth: 1,
      startYear: 1135,
    },
    {
      name: '長承',
      startDay: 1,
      startMonth: 1,
      startYear: 1132,
    },
    {
      name: '天承',
      startDay: 1,
      startMonth: 1,
      startYear: 1131,
    },
    {
      name: '大治',
      startDay: 1,
      startMonth: 1,
      startYear: 1126,
    },
    {
      name: '天治',
      startDay: 1,
      startMonth: 1,
      startYear: 1124,
    },
    {
      name: '保安',
      startDay: 1,
      startMonth: 1,
      startYear: 1120,
    },
    {
      name: '元永',
      startDay: 1,
      startMonth: 1,
      startYear: 1118,
    },
    {
      name: '永久',
      startDay: 1,
      startMonth: 1,
      startYear: 1113,
    },
    {
      name: '天永',
      startDay: 1,
      startMonth: 1,
      startYear: 1110,
    },
    {
      name: '天仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1108,
    },
    {
      name: '嘉承',
      startDay: 1,
      startMonth: 1,
      startYear: 1106,
    },
    {
      name: '長治',
      startDay: 1,
      startMonth: 1,
      startYear: 1104,
    },
    {
      name: '康和',
      startDay: 1,
      startMonth: 1,
      startYear: 1099,
    },
    {
      name: '承徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1097,
    },
    {
      name: '嘉保',
      startDay: 1,
      startMonth: 1,
      startYear: 1095,
    },
    {
      name: '寛治',
      startDay: 1,
      startMonth: 1,
      startYear: 1087,
    },
    {
      name: '応徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1084,
    },
    {
      name: '永保',
      startDay: 1,
      startMonth: 1,
      startYear: 1081,
    },
    {
      name: '承暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1077,
    },
    {
      name: '承保',
      startDay: 1,
      startMonth: 1,
      startYear: 1074,
    },
    {
      name: '延久',
      startDay: 1,
      startMonth: 1,
      startYear: 1069,
    },
    {
      name: '治暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1065,
    },
    {
      name: '康平',
      startDay: 1,
      startMonth: 1,
      startYear: 1058,
    },
    {
      name: '天喜',
      startDay: 1,
      startMonth: 1,
      startYear: 1053,
    },
    {
      name: '永承',
      startDay: 1,
      startMonth: 1,
      startYear: 1046,
    },
    {
      name: '寛徳',
      startDay: 1,
      startMonth: 1,
      startYear: 1044,
    },
    {
      name: '長久',
      startDay: 1,
      startMonth: 1,
      startYear: 1040,
    },
    {
      name: '長暦',
      startDay: 1,
      startMonth: 1,
      startYear: 1037,
    },
    {
      name: '長元',
      startDay: 1,
      startMonth: 1,
      startYear: 1028,
    },
    {
      name: '万寿',
      startDay: 1,
      startMonth: 1,
      startYear: 1024,
    },
    {
      name: '治安',
      startDay: 1,
      startMonth: 1,
      startYear: 1021,
    },
    {
      name: '寛仁',
      startDay: 1,
      startMonth: 1,
      startYear: 1017,
    },
    {
      name: '長和',
      startDay: 1,
      startMonth: 1,
      startYear: 1013,
    },
    {
      name: '寛弘',
      startDay: 1,
      startMonth: 1,
      startYear: 1004,
    },
    {
      name: '長保',
      startDay: 1,
      startMonth: 1,
      startYear: 999,
    },
  ];

  findEraYear(date: Date) {
    return this.jpEras.find(
      (era) => new Date(era.startYear, era.startMonth - 1, era.startDay).getTime() <= date.getTime(),
    );
  }
}
